<template>
	<LayoutMain>
		<div class="navsecondary">
			<RouterLink data-ic="O" :to="{ name: 'CustomerCreate'}">
				<span>Opret institution</span>
			</RouterLink>

			<input type="search" v-model="searchinput" /><i data-ic="Q"></i>
		</div>
		<section>
			<h1>Institutioner</h1>
			<CustomerList v-bind:search="searchinput" />
		</section>

		<transition name="fade">
			<CustomerEdit v-if="isEditOpen || isCreateOpen" />
		</transition>

		<router-view></router-view>
	</LayoutMain>
</template>

<script>
	import LayoutMain from "@/components/common/LayoutMain.vue";
	import CustomerList from "@/components/customers/CustomerList.vue";
	import CustomerEdit from "@/components/customers/CustomerEdit.vue";

	export default {
		name: "Customers",
		data()
		{
			return {
				searchinput: ""
			}
		},
		methods:
		{
			close()
			{
				this.$router.push({ name: "Customers" })
			}
		},
		computed:
		{
			isEditOpen()
			{
				return this.$route.name === "CustomerEdit"
			},
			isCreateOpen()
			{
				return this.$route.name === "CustomerCreate"
			}
		},
		components: {
			CustomerEdit,
			CustomerList,
			LayoutMain
		}
	};
</script>